// List of inventory categories used across the app
export const CATEGORIES = [
  "produce",
  "deli",
  "seafood",
  "meat",
  "bakery",
  "dairy",
  "frozen",
  "beverages",
  "snacks",
  "condiments",
  "spices",
  "dry",
  "canned",
  "prepared",
  "household",
  "personal",
  "pharmacy",
  "pets",
  "flowers",
  "alcohol",
  "other",
] as const;
